"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useInitializeBackgroundFilter = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var _Join = require("../../constants/Join");
/**
 * A hook that handles background filter initialization.
 *
 * This hook manages the initialization state of a background filter,
 * attempting to initialize it once and tracking whether the operation
 * succeeds or fails.
 *
 * @param {Object} params - The parameters object
 * @param {Function} params.initializeBackgroundFilter - Function that returns a promise to initialize the background filter
 * @returns {string} The current initialization state ('PENDING', 'SUCCESS', or 'FAILED')
 */
var useInitializeBackgroundFilter = exports.useInitializeBackgroundFilter = function useInitializeBackgroundFilter(_ref) {
  var initializeBackgroundFilter = _ref.initializeBackgroundFilter;
  var _useState = (0, _react.useState)(_Join.INITIALIZATION_STATE.PENDING),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    status = _useState2[0],
    setStatus = _useState2[1];
  (0, _react.useEffect)(function () {
    if (status !== _Join.INITIALIZATION_STATE.PENDING) return;
    var initializeFilter = /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var _t;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return initializeBackgroundFilter();
            case 1:
              setStatus(_Join.INITIALIZATION_STATE.SUCCESS);
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.warn('Unable to initialize background filter', _t);
              setStatus(_Join.INITIALIZATION_STATE.FAILED);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 2]]);
      }));
      return function initializeFilter() {
        return _ref2.apply(this, arguments);
      };
    }();
    initializeFilter();
  }, [status, initializeBackgroundFilter]);
  return status;
};